import { Component } from '@angular/core';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';

@Component({
    selector: 'gl-about-my-account-popup',
    templateUrl: './about-my-account-popup.component.html',
    styleUrls: ['./about-my-account-popup.component.scss'],
    standalone: false
})
export class AboutMyAccountPopupComponent {
  constructor(private modalRef: ModalOverlayRef) {
    this.modalRef.backgroundClicked();
  }

  public close(result: boolean): void {
    this.modalRef.close(result);
  }
}
